import React, { Component, Fragment } from 'react';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import { AppBar, Cover, Administration, AdministrationLeader, AdministrationAdmin, LogInDialog, ChangeAccountDataDialog, ChangePasswordDialog, SharingManagementDialog, EditRemindersDialog, HelpDialog } from './components'
import deepOrange from '@material-ui/core/colors/deepOrange';
import indigo from '@material-ui/core/colors/indigo';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import request from 'superagent'
import { withCookies } from 'react-cookie'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import './App.css';
import * as Constants from './constants'

const theme = createTheme({
  typography: {
    useNextVariants: true,
  },
  palette: {
    primary: deepOrange,
    secondary: indigo
  },
  icon: {
    fontSize: 20,
    opacity: 0.9,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});

class App extends Component {
  state = {
    state: 0,
    state_admin: 0,
    state_message: "",
    server_settings: null,
    signed_in: false,
    user_data: null,
    snackbar_success_open: false,
    snackbar_error_open: false,
    dialog_sharing_management_open: false,
    dialog_reminders_open: false,
    dialog_change_account_data_open: false,
    dialog_change_password_open: false,
    dialog_help_open: false,
    message: "Action Failed",
    search_string: "",
  }

  constructor(props) {
    super(props)

    //ServerSettings laden
    let currentComponent = this;
    request.post(Constants.BACKEND_URL)
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .set('accept', 'json')
      .send({ command: "getserversettings" })
      .end((err, res) => {
        var result = res.text.trim();
        var server_settings = JSON.parse(result);
        var state = server_settings.state = server_settings.state_right = parseInt(server_settings.state);
        var state_admin = server_settings.state_admin = parseInt(server_settings.state_admin);
        server_settings.state_app = parseInt(server_settings.state_app);
        var state_message;
        if (state === 1) state_message = server_settings.state_1_message.replace("<date1>", server_settings.date1).replace("<date2>", server_settings.date2);
        if (state === 3) state_message = server_settings.state_3_message.replace("<date3>", server_settings.date3).replace("<date4>", server_settings.date4);
        if (state === 6) state_message = server_settings.state_6_message;
        currentComponent.setState({ server_settings: server_settings, state: state, state_admin: state_admin, state_message: state_message });

        //Automatisch anmelden, wenn möglich
        if ((state === 2 || state === 4 || state === 5) && props.cookies.get('staySignedIn')) {
          request.post(Constants.BACKEND_URL)
            .set('Content-Type', 'application/x-www-form-urlencoded')
            .set('accept', 'json')
            .send({ command: "login", email: props.cookies.get('staySignedIn').email, pw: props.cookies.get('staySignedIn').pw })
            .end((err, res) => {
              var result = res.text.trim();
              if (result !== "0") {
                var obj = JSON.parse(result)[0];
                obj.pw = props.cookies.get('staySignedIn').pw;
                obj.email = props.cookies.get('staySignedIn').email;
                currentComponent.onSignedIn(obj);
              } else {
                this.props.cookies.remove('staySignedIn');
                currentComponent.setState({ snackbar_error_open: true, message: "Anmeldung konnte nicht durchgeführt werden" });
              }
            });
        }
      });
  }

  onSignedIn = (user_data) => {
    this.setState({ user_data: user_data, signed_in: true, snackbar_success_open: true, message: "Die Anmeldung war erfolgreich", dialog_change_password_open: (user_data.role === "leader" && user_data.last_login === "0") });
  }

  onSignedOut = () => {
    this.props.cookies.remove('staySignedIn');
    this.setState({ user_data: null, signed_in: false, snackbar_success_open: true, message: "Sie wurden erfolgreich abgemeldet" });
  }

  onChangeAccountData = open => {
    this.setState({ dialog_change_account_data_open: open });
  }

  onChangePassword = open => {
    this.setState({ dialog_change_password_open: open });
  }

  openSharingManagementDialog = opened => {
    this.setState({ dialog_sharing_management_open: opened });
  }

  openHelpDialog = opened => {
    this.setState({ dialog_help_open: opened });
  }

  handleSnackbarClose = () => {
    this.setState({ snackbar_success_open: false, snackbar_error_open: false });
  }

  handleChange = name => event => {
    if (name === "search_string" && event.target.value.includes("@")) { // Autofill in Chrome hat in das Suchfeld die E-Mail eingetragen, sobald im Optionsmenü auf 'Passwort ändern' klickt
      event.target.value = "";
    } else {
      this.setState({ [name]: event.target.value });
    }
  };

  onEditReminders = opened => {
    this.setState({ dialog_reminders_open: opened });
  }

  render() {
    return (
      <BrowserRouter>
        <MuiThemeProvider theme={theme}>
          <div>
            <Routes>
              <Route path={"/" + Constants.FRONTEND_SUB + "/"} exact element={
                <Fragment>
                  {/* Cover */}
                  {(this.state.state === 1 || this.state.state === 3 || this.state.state === 6) && <Cover message={this.state.state_message} />}
                  {/* AppBar */}
                  {(this.state.state === 2 || this.state.state === 4 || this.state.state === 5) && <AppBar signedIn={this.state.signed_in} onSignOut={this.onSignedOut} onChangeAccountData={() => this.onChangeAccountData(true)} onChangePassword={() => this.onChangePassword(true)} userData={this.state.user_data} serverSettings={this.state.server_settings} onOpenSharingManagement={() => this.openSharingManagementDialog(true)} onEditReminders={() => this.onEditReminders(true)} onSearchUpdated={this.handleChange("search_string")} />}
                  {/* LogInDialog */}
                  {(this.state.state === 2 || this.state.state === 4 || this.state.state === 5) && <LogInDialog open={!this.state.signed_in && !this.props.cookies.get('staySignedIn')} onSignedIn={this.onSignedIn} onHelp={() => this.openHelpDialog(true)} serverSettings={this.state.server_settings} admin={false} />}
                  {/* Main Screen */}
                  {this.state.signed_in && <Administration userData={this.state.user_data} server_settings={this.state.server_settings} searchString={this.state.search_string} />}
                  {/* HelpDialog */}
                  {<HelpDialog open={this.state.dialog_help_open} onClose={() => this.openHelpDialog(false)} leader={false} />}
                </Fragment>
              } />
              {/*<Route path={"/"+ Constants.FRONTEND_SUB + "/p/:id"} element={
                <Fragment>
                  {/* Cover }
                  {(this.state.state === 1 || this.state.state === 3 || this.state.state === 6) && <Cover message={this.state.state_message}/>}
                  {/* AppBar }
                  {(this.state.state === 2 || this.state.state === 4 || this.state.state === 5) && <AppBar signedIn={this.state.signed_in} onSignOut={this.onSignedOut} onChangeAccountData={() => this.onChangeAccountData(true)} onChangePassword={() => this.onChangePassword(true)} userData={this.state.user_data} serverSettings={this.state.server_settings} onOpenSharingManagement={() => this.openSharingManagementDialog(true)} onEditReminders={() => this.onEditReminders(true)} onSearchUpdated={this.handleChange("search_string")}/>}
                  {/* LogInDialog }
                  {(this.state.state === 2 || this.state.state === 4 || this.state.state === 5) && <LogInDialog open={!this.state.signed_in && !this.props.cookies.get('staySignedIn')} onSignedIn={this.onSignedIn} onHelp={() => this.openHelpDialog(true)} serverSettings={this.state.server_settings} admin={false} />}
                  {/* Main Screen }
                  {this.state.signed_in && <Administration userData={this.state.user_data} server_settings={this.state.server_settings} searchString={this.state.search_string} ikey={props.match.params.id} />}
                  {/* HelpDialog }
                  {<HelpDialog open={this.state.dialog_help_open} onClose={() => this.openHelpDialog(false)} leader={false}/>}
                </Fragment>
              } />*/}
              <Route path={"/" + Constants.FRONTEND_SUB + "/leader/"} exact element={
                <Fragment>
                  {/* Cover */}
                  {(this.state.state === 1) && <Cover message={this.state.state_message} />}
                  {/* AppBar */}
                  {(this.state.state === 2 || this.state.state === 3 || this.state.state === 4 || this.state.state === 5 || this.state.state === 6) && <AppBar signedIn={this.state.signed_in} onSignOut={this.onSignedOut} onChangeAccountData={() => this.onChangeAccountData(true)} onChangePassword={() => this.onChangePassword(true)} userData={this.state.user_data} serverSettings={this.state.server_settings} onEditReminders={() => this.onEditReminders(true)} onSearchUpdated={this.handleChange("search_string")} />}
                  {/* LogInDialog */}
                  {(this.state.state === 2 || this.state.state === 3 || this.state.state === 4 || this.state.state === 5 || this.state.state === 6) && <LogInDialog open={!this.state.signed_in && !this.props.cookies.get('staySignedIn')} onSignedIn={this.onSignedIn} onHelp={() => this.openHelpDialog(true)} serverSettings={this.state.server_settings} leader={true} />}
                  {/* Main Screen */}
                  {this.state.signed_in && <AdministrationLeader userData={this.state.user_data} server_settings={this.state.server_settings} searchString={this.state.search_string} />}
                  {/* HelpDialog */}
                  {<HelpDialog open={this.state.dialog_help_open} onClose={() => this.openHelpDialog(false)} leader={true} />}
                </Fragment>
              } />
              <Route path={"/" + Constants.FRONTEND_SUB + "/admin/"} exact element={
                <Fragment>
                  {/* Cover */}
                  {(this.state.state_admin === 1 || this.state.state_admin === 3 || this.state.state_admin === 6) && <Cover message={this.state.state_message} />}
                  {/* AppBar */}
                  {(this.state.state_admin === 2 || this.state.state_admin === 4 || this.state.state_admin === 5) && <AppBar signedIn={this.state.signed_in} onSignOut={this.onSignedOut} onChangeAccountData={() => this.onChangeAccountData(true)} onChangePassword={() => this.onChangePassword(true)} userData={this.state.user_data} serverSettings={() => this.modifyServerSettingsAdmin(this.state.server_settings)} onEditReminders={() => this.onEditReminders(true)} onSearchUpdated={this.handleChange("search_string")} />}
                  {/* LogInDialog */}
                  {(this.state.state_admin === 2 || this.state.state_admin === 4 || this.state.state_admin === 5) && <LogInDialog open={!this.state.signed_in && !this.props.cookies.get('staySignedIn')} onSignedIn={this.onSignedIn} onHelp={() => this.openHelpDialog(true)} serverSettings={this.state.server_settings} admin={true} />}
                  {/* Main Screen */}
                  {this.state.signed_in && <AdministrationAdmin userData={this.state.user_data} server_settings={this.state.server_settings} searchString={this.state.search_string} />}
                  {/* HelpDialog */}
                  {<HelpDialog open={this.state.dialog_help_open} onClose={() => this.openHelpDialog(false)} leader={false} />}
                </Fragment>
              } />
            </Routes>
            {/* ChangeAccountDataDialog */}
            {this.state.signed_in && this.state.user_data.role === "normal_user" && <ChangeAccountDataDialog open={this.state.dialog_change_account_data_open} parentId={this.state.user_data.id} onClose={() => this.onChangeAccountData(false)} />}
            {/* ChangePasswordDialog */}
            {this.state.signed_in && (this.state.user_data.role === "normal_user" || this.state.user_data.role === "leader") && <ChangePasswordDialog open={this.state.dialog_change_password_open} leader={this.state.user_data.role === "leader"} parentId={this.state.user_data.id} onClose={() => this.onChangePassword(false)} />}
            {/* SharingManagementDialog */}
            {this.state.signed_in && <SharingManagementDialog open={this.state.dialog_sharing_management_open} onClose={() => this.openSharingManagementDialog(false)} parentId={this.state.user_data.id} />}
            {/* RemindersDialog */}
            {this.state.signed_in && this.state.user_data.role === "normal_user" && <EditRemindersDialog open={this.state.dialog_reminders_open} parentId={this.state.user_data.id} reminders={this.state.user_data.reminders} onCancel={() => this.onEditReminders(false)} onApply={() => this.onEditReminders(false)} />}
            {/* Success Snackbar */}
            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={this.state.snackbar_success_open} autoHideDuration={1500} onClose={this.handleSnackbarClose}>
              <SnackbarContent
                message={
                  <span style={{ display: 'flex', alignItems: 'center' }}>
                    <CheckCircleIcon style={{ fontSize: 20, opacity: 0.9, marginRight: 8 }} />
                    {this.state.message}
                  </span>
                }
                action={[
                  <IconButton color="inherit" onClick={this.handleSnackbarClose}>
                    <CloseIcon style={{ fontSize: 20 }} />
                  </IconButton>,
                ]}
                style={{ backgroundColor: green[600] }} />
            </Snackbar>
            {/* Error Snackbar */}
            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={this.state.snackbar_error_open} autoHideDuration={1500} onClose={this.handleSnackbarClose}>
              <SnackbarContent
                message={
                  <span style={{ display: 'flex', alignItems: 'center' }}>
                    <CheckCircleIcon style={{ fontSize: 20, opacity: 0.9, marginRight: 8 }} />
                    {this.state.message}
                  </span>
                }
                action={[
                  <IconButton color="inherit" key="close" onClick={this.handleSnackbarClose}>
                    <CloseIcon style={{ fontSize: 20 }} />
                  </IconButton>,
                ]}
                style={{ backgroundColor: red[600] }} />
            </Snackbar>
            {/* Loading for Auto Login */}
            {this.props.cookies.get('staySignedIn') && !this.state.signed_in && (this.state.state === 2 || this.state.state === 4 || this.state.state === 5) && <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}><CircularProgress /></div>}
          </div>
          {/* Footer */}
          <div style={{ position: "absolute", height: 30, background: "black", opacity: "0.9", padding: 5, left: 0, right: 0, bottom: 0 }}>
            {!this.state.signed_in && <Button color="primary" style={{ position: "absolute", left: 10, top: 2 }} onClick={() => window.open("https://formulare-schemmerhofen.de/files/fepro/programmheft.pdf", "_blank")}>Programmheft herunterladen</Button>}
            {this.state.signed_in && <Button color="primary" style={{ position: "absolute", left: 10, top: 2 }} onClick={() => this.openHelpDialog(true)}>Hilfe</Button>}
            {this.state.signed_in && <Button color="primary" style={{ position: "absolute", left: 80, top: 2 }} onClick={() => window.open("https://www.schemmerhofen.de/,Lde/Home/Gemeinde+_+Daten/Datenschutz.html", "_blank")}>Datenschutz</Button>}
            {this.state.signed_in && <Button color="primary" style={{ position: "absolute", left: 210, top: 2 }} onClick={() => window.open("https://formulare-schemmerhofen.de/files/fepro/teilnehmende_organisationen.pdf", "_blank")}>Teilnehmende Organisationen</Button>}
            <Typography align="right" color="primary" variant="subtitle1" style={{ position: "absolute", right: 20 }}>{"© Gemeinde Schemmerhofen 2019" + (new Date().getFullYear() === 2019 ? "" : " - " + new Date().getFullYear())}</Typography>
          </div>
        </MuiThemeProvider>
      </BrowserRouter>
    );
  }
}

export default withCookies(App);
